// Team slug for the Goal Club website: <country>_<team>[_<sport>[_<town>]],
// e.g. se_färjestad-bk_icehockey_karlstad. Built the same way as the website's
// club directory ids (club-website src/config/clubDirectory.ts), so a plan and
// a directory club match. The goal sponsor service checks the same format.

const SCANDINAVIAN_LETTERS = 'åäöæø';
const SLUG_PART = '[a-z0-9åäöæø]+(?:-[a-z0-9åäöæø]+)*';

export const TEAM_SLUG_PATTERN = new RegExp(
  `^[a-z]{2}_${SLUG_PART}(?:_${SLUG_PART}){0,2}$`
);
// Group within the club, e.g. a-team, a-women, u21, p12
export const TEAM_TYPE_PATTERN = new RegExp(`^${SLUG_PART}$`);

export const TEAM_SLUG_COUNTRIES = ['se', 'no'];

// Sports in the website's club directory (DirectorySport)
export const TEAM_SLUG_SPORTS = [
  'football',
  'iceHockey',
  'handball',
  'bandy',
  'floorball',
  'basketball',
  'volleyball',
  'skiing',
  'orienteering',
  'athletics',
  'swimming',
  'golf',
  'speedway',
  'americanFootball',
  'multiSport',
];

// Lowercase, å ä ö æ ø kept, other accents removed (é → e), anything else that
// isn't a-z or 0-9 becomes "-". Never produces "_", the part separator.
export const slugifyTeamSlugPart = (value) =>
  Array.from(`${value || ''}`.normalize('NFC').toLowerCase())
    .map((char) =>
      SCANDINAVIAN_LETTERS.includes(char)
        ? char
        : char.normalize('NFD').replace(/[̀-ͯ]/g, '')
    )
    .join('')
    .replace(/[^a-z0-9åäöæø]+/g, '-')
    .replace(/^-|-$/g, '');

// The slug for the given parts, or '' without a team name. A town is only
// used together with a sport (the parts are read by position).
export const buildTeamSlug = ({ country, team, sport, town }) => {
  const teamPart = slugifyTeamSlugPart(team);
  if (!country || !teamPart) {
    return '';
  }
  const sportPart = slugifyTeamSlugPart(sport);
  const townPart = sportPart ? slugifyTeamSlugPart(town) : '';
  return [country, teamPart, sportPart, townPart].filter(Boolean).join('_');
};

// { country, team, sport, town } from a saved slug, or null when it doesn't
// have the current format (e.g. a slug saved during testing).
export const parseTeamSlug = (slug) => {
  const value = `${slug || ''}`.normalize('NFC');
  if (!TEAM_SLUG_PATTERN.test(value)) {
    return null;
  }
  const [country, team, sport = '', town = ''] = value.split('_');
  return { country, team, sport, town };
};
